import { FC } from "react";

import { getLocaleFlagCountryCode, Locales, OrganizationCountry } from "@simplyk/common";
import { ReactCountryFlag } from "react-country-flag";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

interface TranslationColumnHeaderProps {
  role: "main" | "secondary";
  locale: Locales;
  organizationCountry: OrganizationCountry | undefined;
}

export const TranslationColumnHeader: FC<TranslationColumnHeaderProps> = ({ role, locale, organizationCountry }) => {
  const { t } = useTranslate();

  return (
    <DashboardTypography variant="subtitle1" vibe="text-neutral-intense" sx={{ textTransform: "uppercase" }}>
      <ReactCountryFlag
        countryCode={getLocaleFlagCountryCode(locale, organizationCountry)}
        style={{ fontSize: "inherit" }}
        aria-label={t("common", `locale.${locale}`)}
      />{" "}
      {t("dashboard", role === "main" ? "translation.mainLanguage" : "translation.secondaryLanguage", {
        language: t("common", `locale.${locale}`),
      })}
    </DashboardTypography>
  );
};
